// @flow

import _ from 'lodash';
import I18n from '../i18n/I18n';

import BookingConstants from '../constants/BookingConstants';
import Logger from './Logger';

export default class BookingViewUtils {

  static getActionLabel(action: number) {
    switch (action) {
      case BookingConstants.Action.NOT_ARRIVED:
        return I18n.tr('booking.action.not_arrived');
      case BookingConstants.Action.SEATED:
        return I18n.tr('booking.action.placed');
      case BookingConstants.Action.CANCELED:
        return I18n.tr('booking.action.canceled');
      case BookingConstants.Action.NO_SHOW:
        return I18n.tr('booking.action.not_come');
      default:
        Logger.notImplemented('[BookingUtils.getActionLabel] Unknown action label', action);
        return '';
    }
  }

  static getSourceLabel(source: number) {
    switch (source) {
      case BookingConstants.Source.APP:
        return I18n.tr('booking.source.mobile_app');
      case BookingConstants.Source.WEBSITE:
        return I18n.tr('booking.source.website');
      case BookingConstants.Source.RESTAURANT:
        return I18n.tr('booking.source.restaurant');
      case BookingConstants.Source.PHONE:
        return I18n.tr('booking.source.phone');
      case BookingConstants.Source.THIRD_PARTY:
        return I18n.tr('booking.source.third');
      case BookingConstants.Source.PLUGIN:
        return I18n.tr('booking.source.website');
      default:
        Logger.notImplemented('[BookingUtils.getSourceLabel] Unknown source label', source);
        return '';
    }
  }

  static getStatusLabel(status: number) {
    switch (status) {
      case BookingConstants.Status.CONFIRMED:
        return I18n.tr('booking.state.confirmed');
      case BookingConstants.Status.WAITING:
        return I18n.tr('booking.state.waiting');
      default:
        Logger.notImplemented('[BookingUtils.getStatusLabel] Unknown status label', status);
        return '';
    }
  }

  static getPeriodLabel(period: number): string {
    switch (period) {
      case BookingConstants.Period.ALL:
        return I18n.tr('booking.all');
      case BookingConstants.Period.MORNING:
        return I18n.tr('booking.morning');
      case BookingConstants.Period.NOON:
        return I18n.tr('booking.noon');
      case BookingConstants.Period.EVENING:
        return I18n.tr('booking.evening');
      case BookingConstants.Period.BRUNCH:
        return I18n.tr('booking.brunch');
      default:
        Logger.notImplemented('BookingUtils.getPeriodLabel', `Unknown period label ${period}`);
        return '';
    }
  }

  static getPeriodListForPicker(): Array {
    const list = [];
    _.forIn(BookingConstants.Period, (value, key) => {
      // BRUNCH have been deactivated.
      if (value !== BookingConstants.Period.BRUNCH) {
        list.push(
          {
            label: this.getPeriodLabel(value),
            value
          }
        );
      }
    });

    return list;
  }
}
